import { runMutation, runQuery } from '../graphQl'
import { createConfigurationRuleMutation, DeleteAndCreateConfigurationRuleMutation, getRulesQuery, GetStandardMaterialFormFields } from '../query/configurationQuery'

export const createConfigurationRuleApi = async ({ input }) => {
  return runMutation(createConfigurationRuleMutation(), { input }, 'tenant')
}

export const deleteConfigurationRuleApi = ({ validationIds }) => {
  return runMutation(DeleteAndCreateConfigurationRuleMutation(), { validationIds }, 'tenant')
}

export const getRulesApi = () => {
  return runQuery(getRulesQuery(), { }, 'tenant')
}

export const getStandardMaterialFormFieldsApi = ({ fieldIds, templateVersionId }) => {
  return runQuery(GetStandardMaterialFormFields(), { fieldIds, templateVersionId }, 'tenant')
}
